import Dropdown from 'react-bootstrap/Dropdown'
import 'lib/reactBootstrapReact19/dropdown'
import CustomToggle from '../CustomToggle'
import CustomMenu from '../CustomMenu'
import { useState, useRef, useMemo } from 'react'
import styles from './index.module.scss'
import useOutsideOnClick from 'hooks/useOutsideOnClick'
import LoginProfileIcon from '../ProfileIcon'
import useBreakpoint from 'hooks/useBreakPoint'

type NavDropdownProps = {
  navDropdownClass?: string
  children: (props: RenderNavItemHelpers) => JSX.Element
}

const NavDropdown = ({
  navDropdownClass = '',
  children,
}: NavDropdownProps): JSX.Element => {
  const dropdownRef = useRef(null)
  const [isToggleOpen, setToggleState] = useState<boolean>(false)
  const { isMobileScreen } = useBreakpoint()
  const { isCustomSize } = useBreakpoint({ maxWidth: 450 })

  const dropDirection = isCustomSize ? 'down' : 'left'

  const outsideClickCallback = () => {
    if (isToggleOpen) {
      setToggleState(false)
    }
  }

  useOutsideOnClick({
    containerRef: dropdownRef,
    callback: outsideClickCallback,
  })

  const resetToggle = () => {
    setToggleState(false)
  }

  const navIcon = useMemo(() => {
    if (isMobileScreen) {
      return isToggleOpen ? 'cross' : 'hamburger'
    }

    return null
  }, [isMobileScreen, isToggleOpen])

  return (
    <Dropdown
      drop={dropDirection}
      className={`${styles.nav_dropdown} mr-0`}
      ref={dropdownRef}
    >
      <Dropdown.Toggle
        as={CustomToggle}
        //show cross icon only for small screen sizes when dropdown menu is open
        //otherwise always show hamburger icon
        icon={navIcon}
        isToggleOpen={isToggleOpen}
        setToggleState={setToggleState}
        containerClassName={navDropdownClass}
        anchorClassName="ml-1"
        iconClassName={styles.navbar_icon}
      >
        {!isMobileScreen && <LoginProfileIcon isToggleOpen={isToggleOpen} />}
      </Dropdown.Toggle>
      <Dropdown.Menu as={CustomMenu}>
        {children({
          resetToggle,
        })}
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default NavDropdown
